import { useCallback, useContext, useEffect } from "react";
import api from "../../services/api";
import UserPermission from "../../components/UserPermission";
import moment from "moment";
import { MapContext } from "../../contexts/MapFilterContext";

export function useMapFilter() {

    const userPermission = UserPermission();

    const {
        setComplaints,
        neighborhood, area, group,
        stateOccurrence, status, stepStatus,
        late, rangeOccurrences, complaintTarget,
        setLoading, setSelectedItem,
        setMapPosition, statusesList,
        setMapZoom,
        evaluation,
        ...props
    } = useContext(MapContext);

    console.log('status:', status);
    console.log('stepStatus:', stepStatus);

    const buildFilter = useCallback(({
        neighborhood, area, group,
        stateOccurrence, status, stepStatus,
        late, rangeOccurrences, complaintTarget,
        evaluation
    }) => {
        let filter = {
            order: "createdAt DESC",
            where: {
                createdAt: {
                    between: [
                        moment(rangeOccurrences.startDate).toISOString(),
                        //moment(rangeOccurrences.endDate).toISOString()
                        moment(rangeOccurrences.endDate).endOf('day').toISOString()
                    ]
                },
                and: [
                    { longitute: { neq: 0 } },
                    { longitute: { neq: null } },
                    { latitude: { neq: 0 } },
                    { latitude: { neq: null } }
                ]
            },
            fields: ['id', 'area', 'group', 'createdAt', 'status', 'neighborhood', 'reference', 'datePrevision', 'validationControl', 'longitute', 'latitude', 'statusStep', 'evaluation'],
            limit: 1000,
        };

        if (status !== "Todos") {
            filter.where.status = status;
        }

        if (stepStatus !== "Todos") {
            // Mapeamento de Etapa dos Status para os status correspondentes
            const stepStatusMapping = {
                'Abertura': ['Novo'],
                'Homologação': ['Em análise', 'Aguardando Informação', 'Autorizado/Aprovado', 'Solução de longo prazo / Sugestão de projeto'],
                'Execução': ['Em execução', 'Encaminhado para o executor', 'Notificado para providências'],
                'Conclusão': ['Resolvido', 'Indeferido', 'Respondido', 'Detecção incorreta']
            };

            const statusValues = stepStatusMapping[stepStatus];
            if (statusValues && statusValues.length > 0) {
                filter.where.status = { inq: statusValues };
            }
        }

        if (area !== "Todos") {
            filter.where.area = area;
        }

        if (complaintTarget !== "Todos") {
            filter.where.complaintTarget = complaintTarget;
        }

        if (stateOccurrence !== "Todos") {
            filter.where.validationControl = stateOccurrence;
        }

        if (group !== "Todos") {
            filter.where.group = group;
        }

        if (neighborhood?.name !== "Todos") {
            filter.where.neighborhood = neighborhood?.name;
        }

        if (late !== "Todos") {
            filter.where.datePrevision = late === "true"
                ? { lt: moment().startOf('day').toISOString() }
                : { gte: moment().startOf('day').toISOString() };
        }

        if (evaluation !== "Todos") {
            filter.where.evaluation = { neq: null };
        }

        return filter;
    }, []);

    const updateOccurences = useCallback(async (data) => {
        const filter = buildFilter(data);

        setLoading(true);

        const { data: complaints } = await api.get(`${userPermission}/complaints?filter=${JSON.stringify(filter)}`);

        setLoading(false);

        setComplaints(complaints);
        setSelectedItem(-1);
        setMapPosition([-6.5319859, -49.8526823]);
        setMapZoom(14);
    }, [buildFilter, setComplaints, setLoading, setSelectedItem, setMapPosition, setMapZoom, userPermission]);

    useEffect(() => {
        updateOccurences({
            neighborhood, area, group,
            stateOccurrence, status, stepStatus,
            late, rangeOccurrences, complaintTarget,
            statusesList,
            evaluation
        });
    }, [
        updateOccurences,
        userPermission, statusesList,
        neighborhood, area, group,
        stateOccurrence, status, stepStatus,
        late, rangeOccurrences, complaintTarget,
        evaluation
    ]);


    return {
        setComplaints,
        neighborhood,
        area,
        group,
        stateOccurrence,
        status,
        stepStatus,
        late,
        rangeOccurrences,
        complaintTarget,
        setLoading,
        setSelectedItem,
        setMapPosition,
        setMapZoom,
        statusesList,
        evaluation,
        ...props
    }
}